import { combineReducers, configureStore } from '@reduxjs/toolkit';
import { restoreSpcSession, saveSpcSession } from './SpcSession';
import { bannerReducer, diagramReducer, gearboxReducer, layoutReducer, loadReducer, motorReducer, translationReducer, startingConstraintReducer } from '.';

const reducer = combineReducers({
    banner: bannerReducer,
    layout: layoutReducer,
    translation: translationReducer,
    motor: motorReducer,
    diagram: diagramReducer,
    load: loadReducer,
    gearbox: gearboxReducer,
    startingConstraint: startingConstraintReducer
});

export type RootState = ReturnType<typeof reducer>;

export const store = configureStore({
    reducer,
    preloadedState: restoreSpcSession()
});

// Save settled changes without serializing all curves on every slider action.
let saveTimer: ReturnType<typeof setTimeout> | undefined;
store.subscribe(() => {
    clearTimeout(saveTimer);
    saveTimer = setTimeout(() => saveSpcSession(store.getState()), 250);
});
window.addEventListener('pagehide', () => saveSpcSession(store.getState()));

export type AppDispatch = typeof store.dispatch;
